import React, { useState, useEffect } from 'react';
import { Button, Grid, Link } from '@mui/material';
import ImageComponents from '../../../../Shared/ImageComponents';
import Loader from '../../Components/loader';
import CustomizedDialogs from '../../../../Shared/CustomDialogs';
import RazorPayDialog from './Components/RazorPayDialog';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBackspace } from '@fortawesome/free-solid-svg-icons/faBackspace';
import { faInr } from '@fortawesome/free-solid-svg-icons';
import { faLongArrowLeft } from '@fortawesome/free-solid-svg-icons/faLongArrowLeft';


function WalletPayment({payModesToPass , displayOrderNo, rzpWalletTextChangeToHide, rzpWalletPartnerCode}) {

  const [selectedWallet, setSelectedWallet] = useState('');
  const [selectBankName, setBankName] = useState('');
  const [selectBankCode, setBankCode] = useState('');
  const [bankList, setBankList] = useState(null);
  const [txnurl , settxnurl ] = useState('');
  const [pgpayload , setpgpayload] = useState('');
  const [codeList , setcodeList] = useState([]);
  const [walleterror , setwalleterror] = useState(false);
  const [showLoader, setshowLoader] = useState(false);
  const [showRazorPay, setShowRazorPay] = useState(false);
  const [rzpWalletbalance , setRzpWalletbalance] = useState('');
  const [balance, setBalance] = useState(null);
  const [showWallets, setShowWallets] = useState(true);
  
  const handleBalanceUpdate = (newBalance) => {
 	setBalance(newBalance);
 	setShowWallets(false);
 	setShowRazorPay(false);
 	
  };

  const handleCloseDialog = () => {
    setShowRazorPay(false);
    setBankCode('');
  };

  
  let form;

  useEffect(() => {
    if (payModesToPass) {
      const PPIMethod = payModesToPass.find(method => method.code === 'PPI');
      const PPIBanks = PPIMethod ? PPIMethod.subPayModes : null;
      setBankList(PPIBanks);

      if (PPIBanks) {
        const bankcodes = PPIBanks.map(item => item.code);
        setcodeList(bankcodes);
      }
    }
  }, [payModesToPass]); 
  
  
    useEffect(() => {
        if (selectBankCode) {
             setwalleterror(false);
         }
    }, [selectBankCode]); 

    const handleRzpClose = async () => {
    setShowWallets(true);
    setBalance(null);
    }	
	
  const handlePayNow = async () => {
  
    if(selectBankCode > 0){
    setshowLoader(true);
    const queryParameters = new URLSearchParams(window.location.search);
    const order = queryParameters.get("orderNo");
    const mode = "PPI";

    try {
      const response = await fetch('/pay/securePayment/process/paymentui', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          orderNo: order,
          mode: mode,
          ppiCode: selectBankCode,
          displayOrderNo:displayOrderNo
        })
      });
      const data = await response.json();
      
      if(data.as ===1){
      if(data.pgPayload.form){
      const formHtml = data.pgPayload.form;
      const tempContainer = document.createElement('div');
      tempContainer.innerHTML = formHtml;
      const formElement = tempContainer.querySelector('form');
      document.body.appendChild(formElement);
      setshowLoader(false);
      formElement.submit();
      }
      else if(data.txnURL){
       settxnurl(data.txnURL);
       setpgpayload(data.pgPayload);
       await delay(1500);
       form = document.getElementById('testForm');
       form.submit();
      
      }
      
      
      }    } catch (error) {
       setshowLoader(false);
        console.error('Error:', error);
        
    }
    }else{
    setwalleterror(true);
    }
    }

const delay = millis => new Promise((resolve, reject) => {
  setTimeout(_ => resolve(), millis)
});
  
  return (
  <>
   {showLoader && <Loader show={true} textToShow="Please wait while your transaction is being processed"/>}
   {pgpayload && (
    <form method="post" action={txnurl} id="testForm">
        {Object.keys(pgpayload).map((key, index) => (
            <input key={index} type="hidden" id={key} name={key} value={pgpayload[key]} />
        ))}
    </form>
)} 
{showWallets && (
<div className='card-details'>
      <div className='card-detail-form'>
        <h5>
          Select Wallet app
        </h5>
        <Grid container spacing={3}>
           
          <Grid item md={12} xs={12} >
            <div className='card-info'>
              <ul className='wallet-box'>
            {codeList && codeList.includes("8") && (
           <li className={selectBankCode === '8' ? 'active' : ''} onClick={() => setBankCode('8')}>
                  <Link className='phone-pay'>
                    <ImageComponents name={'PhonePe'} />
                  </Link>
                </li>)}
                 {codeList && codeList.includes("6") && (
           <li className={selectBankCode === '6' ? 'active' : ''} onClick={() => setBankCode('6')}>
                  <Link className='airtel'>
                    <ImageComponents name={'Airtel Money'} />
                  </Link>
                </li>)}
                {codeList && codeList.includes("9") && (
           <li className={selectBankCode === '9' ? 'active' : ''} onClick={() => setBankCode('9')}>
                  <Link className='jio-money'>
                    <ImageComponents name={'Jio Money'} />
                  </Link>
                </li>)}
                 {codeList && codeList.includes("5") && (
           <li className={selectBankCode === '5' ? 'active' : ''} onClick={() => setBankCode('5')}>
                  <Link className='free-charge'>
                    <ImageComponents name={'FreeCharge Wallet'} />
                  </Link>
                </li>)}
                 {codeList && codeList.includes("3") && (
           <li className={selectBankCode === '3' ? 'active' : ''} onClick={() => setBankCode('3')}>
                  <Link className='pay-zap'>
                    <ImageComponents name={'PAYZAPP'} />
                  </Link>
                </li>)}
                {codeList && codeList.includes("4") && (
           <li className={selectBankCode === '4' ? 'active' : ''} onClick={() => setBankCode('4')}>
                  <Link className='ola-money'>
                    <ImageComponents name={'OLA Money'} />
                  </Link>
                </li>)}
                 {codeList && codeList.includes("10") && (
           <li className={selectBankCode === '10' ? 'active' : ''} onClick={() => setBankCode('10')}>
                  <Link className='mobikwick'>
                    <ImageComponents name={'Mobikwik'}/>
                  </Link>
                </li>)}
                 {codeList && codeList.includes("13") && (
           <li className={selectBankCode === '13' ? 'active' : ''} onClick={() => setBankCode('13')}>
                  <Link className='paytm'>
                    <ImageComponents name={'Paytm'} />
                  </Link>
                </li>)}
                 {codeList && codeList.includes("7") && (
           <li className={selectBankCode === '7' ? 'active' : ''} onClick={() => setBankCode('7')}>
                  <Link className='oxygen'>
                    <ImageComponents name={'Oxigen Wallet'} />
                  </Link>
                </li>)}
               {codeList && codeList.includes("11") && (
           <li className={selectBankCode === '11' ? 'active' : ''} onClick={() => setBankCode('11')}>
                  <Link className='amazon'>
                    <ImageComponents name={'Amazon Pay'} />
                  </Link>
                </li>)}
		{codeList && codeList.includes("14") && (
           <li className={selectBankCode === '14' ? 'active' : ''} onClick={() =>  { setBankCode('14'); setShowRazorPay(true); }}  >
                  <Link className='razorpay'>
                    <ImageComponents style={{ height: '30px' }} name={'Razorpay Wallet'} />
                  </Link>
                </li>)}
              </ul>
            </div>
          </Grid>
         {walleterror && (
      <p style={{ color: 'red'  ,  marginLeft: '30px' }}>Please select a bank!</p>
    )}
   </Grid>
          <div className='autopay-check'>
            <Button variant="outlined" size="large" className='pay-now-btn' onClick={handlePayNow}>
              Pay now
            </Button>
          </div>
          <div className='note-box'>

            <span>
              <ImageComponents name={"notesIcon"} />
            </span>
            <h5>Please note</h5>
            <p>As per government regulations, wallets cannot be used for transactions more than Rs. 1,00,000 per month</p>
          </div>
        </div>
        <style>
          {`
          .selected {
            background-color: #f0f0f0; /* Light gray background */
          }
        `}
        </style>
    </div>)}
     {balance ? <div className='razor-wallet-box'>
      <h3><button className='back-btn' onClick={handleRzpClose}><FontAwesomeIcon icon={faLongArrowLeft}></FontAwesomeIcon> </button>RazorPay Wallet</h3>
      <h6 className='current-bal'>Your Current Balance</h6>
      <p className='inr'><FontAwesomeIcon icon={faInr}/>{balance}</p>
      <div className='card-details'>
      <div className='card-detail-form'>
      <div className='autopay-check'>
            <Button variant="outlined" size="large" className='pay-now-btn' onClick={handlePayNow}>
              Continue
            </Button>
          </div></div></div>
    </div>: null}
    {showRazorPay ? <CustomizedDialogs  className='razor-pay-dialog'  open={showRazorPay} handleClose={() => setShowRazorPay(false)}>
      <RazorPayDialog handleCloseDialog={handleCloseDialog}   displayOrderNo ={displayOrderNo}  onBalanceUpdate={handleBalanceUpdate} rzpWalletTextChangeToHide={rzpWalletTextChangeToHide} rzpWalletPartnerCode={rzpWalletPartnerCode}/>
    </CustomizedDialogs>
    : null}
    </>
  )
}

export default WalletPayment;

